import { render } from "./ByHolderTab.vue?vue&type=template&id=25691b28"
import script from "./ByHolderTab.vue?vue&type=script&lang=ts"
export * from "./ByHolderTab.vue?vue&type=script&lang=ts"
script.render = render

export default script